import React from 'react';
import { Box, SxProps, Theme, Tooltip } from '@mui/material';

import { CandidateRegionOrder, getCandidateRegion } from '@utils';

const regionTagSx: SxProps<Theme> = (theme) => ({
  gridArea: '1 / 1',
  display: 'inline-flex',
  alignItems: 'center',
  height: '1rem',
  px: 0.5,
  borderRadius: '2px',
  backgroundColor: theme.palette.highlight.neutral,
  color: theme.palette.text.secondary,
  fontSize: '0.625rem',
  lineHeight: 1,
  fontWeight: 500,
});

export const RegionTag: React.FC<{ country?: string | null }> = ({
  country,
}) => {
  const region = getCandidateRegion(country);

  return (
    <Box display="grid" justifyItems="start">
      {CandidateRegionOrder.filter((label) => label !== region).map((label) => (
        <Box
          key={label}
          component="span"
          aria-hidden
          visibility="hidden"
          sx={regionTagSx}
        >
          {label}
        </Box>
      ))}
      <Tooltip title={country || 'Location unknown'} placement="top">
        <Box component="span" sx={regionTagSx}>
          {region}
        </Box>
      </Tooltip>
    </Box>
  );
};
